import type { ja } from '.'

// キーと値の間に改行が入ると翻訳システムと連携できなくなるため、prettier-ignoreしている
// prettier-ignore
export const locale = {
  'smarthr-ui/common/language': 'やさしい日本語',
  'smarthr-ui/ActionDialog/closeButtonLabel': 'キャンセル',
  'smarthr-ui/AppHeader/school': 'SmartHRスクール',
  'smarthr-ui/AppHeader/help': 'わからないとき',
  'smarthr-ui/AppHeader/userSettings': 'あなたの　設定',
  'smarthr-ui/AppHeader/releaseNotes': 'リリースノート',
  'smarthr-ui/AppHeader/releaseNotesLoadError': 'リリースノートが　表示できません。\n時間が　たってから、やりなおしてください。',
  'smarthr-ui/AppHeader/seeAllReleaseNotes': 'すべての　リリースノートを　見る',
  'smarthr-ui/AppHeader/DesktopHeader/appLauncherLabel': 'アプリ',
  'smarthr-ui/AppHeader/MobileHeader/account': 'アカウント',
  'smarthr-ui/AppHeader/MobileHeader/openMenu': 'メニューを　みる',
  'smarthr-ui/AppHeader/MobileHeader/closeMenu': 'メニューを　とじる',
  'smarthr-ui/AppHeader/MobileHeader/allAppButton': '全部のアプリ',
  'smarthr-ui/AppHeader/MobileHeader/managementMenu': '管理メニュー',
  'smarthr-ui/AppHeader/MobileHeader/latestReleaseNotes': 'いちばん　あたらしい　リリースノート',
  'smarthr-ui/AppHeader/MobileHeader/back': 'もどる',
  'smarthr-ui/AppHeader/MobileHeader/openMenuAccordion': '見る',
  'smarthr-ui/AppHeader/MobileHeader/closeMenuAccordion': '閉じる',
  'smarthr-ui/AppHeader/Launcher/searchInputTitle': 'アプリを　名前で　調べます。',
  'smarthr-ui/AppHeader/Launcher/favoriteModeText': 'よく使うアプリ',
  'smarthr-ui/AppHeader/Launcher/allModeText': '全部のアプリ',
  'smarthr-ui/AppHeader/Launcher/listText': 'アプリのリスト',
  'smarthr-ui/AppHeader/Launcher/helpText': 'よく使う　アプリ　とは',
  'smarthr-ui/AppHeader/Launcher/searchResultText': '見つかった　アプリ',
  'smarthr-ui/AppHeader/Launcher/emptyText': 'あてはまる　アプリは　ありません。',
  'smarthr-ui/AppHeader/Launcher/sortDropdownLabel': '並べる',
  'smarthr-ui/AppHeader/Launcher/sortDropdownSelected': '選んだ',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderDefault': '普通',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameAsc': 'アプリの名前（上から）',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameDesc': 'アプリの名前（下から）',
  'smarthr-ui/AppLauncher/showAllText': 'すべて　見る',
  'smarthr-ui/AppLauncher/triggerLabel': 'アプリ',
  'smarthr-ui/Browser/notFoundDescription': '別の内容を　入れて　もう一度　ためして　ください。',
  'smarthr-ui/Browser/notFoundTitle': 'あてはまる　ものは　ありません。',
  'smarthr-ui/Button/loading': '処理している',
  'smarthr-ui/Calendar/currentYear': 'いまの　年',
  'smarthr-ui/Calendar/nextMonth': 'つぎの　月へ',
  'smarthr-ui/Calendar/previousMonth': 'まえの　月へ',
  'smarthr-ui/Calendar/selectYear': '年を　選ぶ',
  'smarthr-ui/Combobox/addItemButtonLabel': '「{name}」を　足す',
  'smarthr-ui/Combobox/loadingText': '処理している',
  'smarthr-ui/Combobox/noResultsText': 'あてはまる　ものは　ありません。',
  'smarthr-ui/DropdownMenuButton/triggerActive': 'えらべる　ものを　とじる',
  'smarthr-ui/DropdownMenuButton/triggerInactive': 'えらべる　ものを　みる',
  'smarthr-ui/DropZone/selectButtonLabel': 'ファイルを　選ぶ',
  'smarthr-ui/FileViewer/rotateAlt': 'ひだりに　まわす',
  'smarthr-ui/FileViewer/scaleDownAlt': '小さくする',
  'smarthr-ui/FileViewer/scaleRateLabel': 'おおきさ（％）',
  'smarthr-ui/FileViewer/scaleUpAlt': '大きくする',
  'smarthr-ui/FileViewer/unsupportedFileText': 'この　種類の　ファイルは　見られません。',
  'smarthr-ui/FilterDropdown/applyText': '使う',
  'smarthr-ui/FilterDropdown/cancelText': 'キャンセル',
  'smarthr-ui/FilterDropdown/resetText': 'さいしょの　表示に　もどす',
  'smarthr-ui/FilterDropdown/status': 'しぼりこんだ　まま',
  'smarthr-ui/FilterDropdown/triggerText': 'しぼりこむ',
  'smarthr-ui/FormDialog/closeButtonLabel': 'キャンセル',
  'smarthr-ui/InformationPanel/closeButtonLabel': '閉じる',
  'smarthr-ui/InformationPanel/openButtonLabel': '見る',
  'smarthr-ui/InputFile/destroy': '消します',
  'smarthr-ui/LanguageSwitcher/checkIconAlt': '選んだ',
  'smarthr-ui/Loader/alt': '処理している',
  'smarthr-ui/MessageDialog/closeButtonLabel': '閉じる',
  'smarthr-ui/ModelessDialog/closeButtonIconAlt': '閉じる',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaLabel': 'ダイアログの　場所',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaRoleDescription': 'おしたまま　うごかせます',
  'smarthr-ui/ModelessDialog/dialogHandlerDescription': 'やじるしキーで　うえ・した・ひだり・みぎに　うごかせます',
  'smarthr-ui/ModelessDialog/dialogHandlerLiveRegionText': 'うえから{top}px、ひだりから{left}px',
  'smarthr-ui/MultiCombobox/destroyButtonIconAltSuffix': 'を　消します',
  'smarthr-ui/MultiCombobox/selectedListAriaLabel': '選んだ　もの',
  'smarthr-ui/NotificationBar/closeButtonIconAlt': '閉じる',
  'smarthr-ui/Pagination/controllerItemButtonFirstLabel': '最初へ',
  'smarthr-ui/Pagination/controllerItemButtonLastLabel': '最後へ',
  'smarthr-ui/Pagination/controllerItemButtonNextLabel': '次へ',
  'smarthr-ui/Pagination/controllerItemButtonPreviousLabel': '前へ',
  'smarthr-ui/Pagination/itemButtonLabel': '{page}ページめ',
  'smarthr-ui/Pagination/navigationLabel': 'ページの　移動',
  'smarthr-ui/RequiredLabel/text': 'ひつよう',
  'smarthr-ui/SearchInput/iconAlt': 'さがす',
  'smarthr-ui/SideMenu/navigationLabel': 'サイドメニュー',
  'smarthr-ui/SingleCombobox/destroyButtonIconAlt': 'けす',
  'smarthr-ui/SortDropdown/applyText': '決める',
  'smarthr-ui/SortDropdown/ascLabel': '上から　小さい順',
  'smarthr-ui/SortDropdown/cancelText': 'キャンセル',
  'smarthr-ui/SortDropdown/descLabel': '上から　大きい順',
  'smarthr-ui/SortDropdown/sortFieldLabel': 'どれで　並べるか',
  'smarthr-ui/SortDropdown/sortOrderLegend': '並べ方',
  'smarthr-ui/StepFormDialog/backButtonLabel': 'もどる',
  'smarthr-ui/StepFormDialog/closeButtonLabel': 'キャンセル',
  'smarthr-ui/StepFormDialog/nextButtonLabel': '次へ',
  'smarthr-ui/StepStatusIcon/closedAlt': 'とちゅうで　とじた',
  'smarthr-ui/StepStatusIcon/completedAlt': 'おわった',
  'smarthr-ui/Textarea/availableLetters': 'あと　{availableLetters}　文字',
  'smarthr-ui/Textarea/maxLettersExceeded': '{exceededLetters}文字　オーバー',
  'smarthr-ui/Textarea/screenReaderMaxLettersDescription': 'いちばん多く　{maxLetters}文字　入れられます',
  'smarthr-ui/OpenInNewTabIcon/openInNewTab': 'あたらしい　タブで見る',
  'smarthr-ui/Th/sortDirectionAsc': '上から　小さい順',
  'smarthr-ui/Th/sortDirectionDesc': '上から　大きい順',
  'smarthr-ui/Th/sortDirectionNone': '並べかえなし',
  'smarthr-ui/ThCheckbox/checkAllInvisibleLabel': 'すべての　項目を　えらぶ/やめる',
  'smarthr-ui/ThCheckbox/checkColumnName': 'えらぶ',
} as const satisfies Record<keyof typeof ja, string>
